// extracted by mini-css-extract-plugin
export default {"EventsList":"EventsList_EventsList__k0WI-","wrapper":"EventsList_wrapper__2kXIL"};